module.exports = __webpack_public_path__ + "img/red_envelopese.83354852.png";